import script from "./AccountDetailCredit.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountDetailCredit.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__